<template>
  <div class="check-detail">
    <global-header title="单品验货"/>
    <tab-page>
      <check-info-tab title="基础信息" name="basic" :detail="orderItemDetail"/>
      <check-items-tab title="检查项" name="items" :id="singleProductId" :order-item-id="orderItemId" :order-item-detail="orderItemDetail"/>
    </tab-page>
  </div>
</template>

<script>
import GlobalHeader from '@/components/Common/GlobalHeader.vue'
import TabPage from '@/components/Common/TabPage.vue'
import CheckInfoTab from '@/components/CheckDetail/CheckInfoTab.vue'
import CheckItemsTab from '@/components/CheckDetail/CheckItemsTab.vue'
import {getAction} from '@/api/manage';
import inobounce from 'inobounce';

export default {
  name: 'checkDetail',
  components: {CheckItemsTab, CheckInfoTab, TabPage, GlobalHeader},
  data() {
    return {
      orderItemId: this.$route.query.orderItemId,
      singleProductId: this.$route.query.singleProductId,
      orderItemDetail: {}
    }
  },
  created() {
    this.getOrderItemDetail()
  },
  mounted() {
    let u = navigator.userAgent
    if (u.indexOf('iPhone') > -1) {
      inobounce.enable()
    }
  },
  beforeDestroy() {
    inobounce.disable()
  },
  methods: {
    async getOrderItemDetail() {
      const res = await getAction('/jeecg-system/task/taskOrderItem/queryById', {
        id: this.orderItemId
      })
      if (res.success) {
        this.orderItemDetail = res.result
        this.orderItemDetail.title = `${res.result.orderNo}-${res.result.singleProductNo}-${res.result.singleProductName}`
      } else {
        this.Toast.fail(res.message)
      }
    }
  }
}
</script>

<style scoped>

</style>
